import { render, staticRenderFns } from "./appdash.vue?vue&type=template&id=501ca762&scoped=true&"
import script from "./appdash.vue?vue&type=script&lang=js&"
export * from "./appdash.vue?vue&type=script&lang=js&"
import style0 from "./appdash.vue?vue&type=style&index=0&id=501ca762&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501ca762",
  null
  
)

export default component.exports